<template>
  <Modal
    :show="show"
    :disabled="!isValid || loading"
    action-text="Send Invite"
    cancel-text=""
    width="medium"
    @action="submit"
    @close="close"
  >
    <template #title>
      Invite User
    </template>

    <template #content>
      Invite recruiters and hiring managers to view and edit all posts on your account

      <v-form @submit.prevent="$emit('submit')">
        <DpplFormField
          field-name="email"
          :form="form"
          class="pt-6"
          @update:model-value="$emit('update:modelValue', $event)"
          @change="$emit('change', $event)"
        >
          <template #field="{ props, on }">
            <DpplTextField
              label="Email Address"
              :disabled="loading"
              v-bind="props"
              v-on="on"
            />
          </template>
        </DpplFormField>
      </v-form>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/shared/Modal.vue';
import DpplTextField from '@/components/datapeople/DpplTextField.vue';
import DpplFormField from '@/components/datapeople/DpplFormField.vue';

export default {
  name: 'InviteModal',
  components: {
    Modal,
    DpplTextField,
    DpplFormField,
  },
  props: {
    show: { type: Boolean, default: false },
    isValid: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    form: { type: Object, default: () => ({}) },
  },
  emits: ['submit', 'update:modelValue', 'change', 'close'],
  methods: {
    close() {
      this.$emit('close');
    },
    submit() {
      this.$emit('submit');
    },
  },
};
</script>
